module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House48.9ead5ce3.jpg";